<template>
  <div class="auth-modal" v-if="isVisible">
    <div class="register-form-container">
      <!-- Step 1: User Information -->
      <div v-if="step === 1">
        <h2>Create New Account</h2>
        <form @submit.prevent="handleStep1Submit">
          <div v-if="error" class="error-message">{{ error }}</div>
          <div class="form-group">
            <label for="register-givenName">First Name</label>
            <input id="register-givenName" v-model="givenName" type="text" required :disabled="isRegistering" />
          </div>
          <div class="form-group">
            <label for="register-familyName">Last Name</label>
            <input id="register-familyName" v-model="familyName" type="text" required :disabled="isRegistering" />
          </div>
          <!-- <div class="form-group">
            <label for="register-phone-number">Phone Number</label>
            <input id="register-phone-number" v-model="phone_number" type="tel" :disabled="isRegistering" />
          </div> -->
          <div class="form-group">
            <label for="register-email">Email</label>
            <input id="register-email" v-model="email" type="email" required :disabled="isRegistering" />
          </div>
          <div class="form-group">
            <label for="register-password">Password</label>
            <div class="password-wrapper">
              <input id="register-password" :type="showPassword ? 'text' : 'password'" v-model="password" required :disabled="isRegistering" />
				<button type="button" class="toggle-eye" @click="showPassword = !showPassword" tabindex="-1">
					{{ showPassword ? '👁️' : '👁️‍🗨️' }}
				</button>
            </div>
          </div>
          <div class="form-group">
            <label for="register-confirm-password">Confirm Password</label>
            <input id="register-confirm-password" :type="showPassword ? 'text' : 'password'" v-model="confirmPassword" required :disabled="isRegistering" />
          </div>
          <div class="button-row">
			<button type="submit" class="user-modal-submit-btn green" :disabled="isRegistering">
				{{ isRegistering ? 'Registering...' : 'Register' }}
			</button>
			<button type="button" class="cancel-btn" @click="closeModal" :disabled="isRegistering">
				Cancel
			</button>
			</div>
        </form>
      </div>

      <!-- Step 2: Verification Code -->
      <div v-if="step === 2">
        <VerificationStep
          :type="verificationType"
          :target="verificationTarget"
          :error="error"
          :loading="isConfirming"
          showBack
          @confirm="handleStep2Submit"
          @back="goBack"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VerificationStep from './VerificationStep.vue';

export default {
	name: 'RegisterModal',
	components: {
		VerificationStep
	},
	props: {
		isVisible: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			step: 1,
			givenName: '',
			familyName: '',
			phone_number: '',
			email: '',
			password: '',
			confirmPassword: '',
			verificationCode: '',
			verificationType: 'email', // 'email' or 'phone'
			verificationTarget: '',   // actual email or phone number
			showPassword: false,
			isRegistering: false,
			isConfirming: false,
			error: ''
		};
	},
	methods: {
		handleKeydown(e) {
			if (e.key === 'Escape' && this.isVisible) {
				this.closeModal();
			}
		},
		handleStep1Submit() {
			this.error = '';
			if (this.password !== this.confirmPassword) {
				this.error = 'Passwords do not match.';
				return;
			}
			this.isRegistering = true;
			let phone = this.phone_number;
			if (phone && typeof phone === 'string' && phone.trim() !== '' && !phone.trim().startsWith('+')) {
				phone = '+' + phone.trim();
			}
			this.$emit('register', {
				givenName: this.givenName,
				familyName: this.familyName,
				phone_number: phone,
				email: this.email,
				password: this.password
			});
		},
		handleStep2Submit(payload) {
			this.error = '';
			const code = payload.code;
			this.isConfirming = true;
			this.$emit('confirm', {
				email: this.email,
				code: code,
				type: this.verificationType
			});
		},
		nextStep(type = 'email', target = '') {
			this.isRegistering = false;
			this.step = 2;
			this.error = '';
			this.verificationType = type;
			this.verificationTarget = target || (type === 'phone' ? this.phone_number : this.email);
			this.verificationCode = '';
		},
		setError(message) {
			this.error = message;
			this.isRegistering = false;
			this.isConfirming = false;
		},
		goBack() {
			this.step = 1;
			this.error = '';
			this.verificationCode = '';
		},
		showVerificationStep(target, errorMsg = '', type = 'email') {
			this.step = 2;
			this.verificationTarget = target;
			this.verificationType = type;
			this.error = errorMsg;
			this.isRegistering = false;
			this.isConfirming = false;
		},
		closeModal() {
			this.reset();
			this.$emit('cancel');
		},
		reset() {
			this.step = 1;
			this.givenName = '';
			this.familyName = '';
			this.phone_number = '';
			this.email = '';
			this.password = '';
			this.confirmPassword = '';
			this.verificationCode = '';
			this.verificationType = 'email';
			this.verificationTarget = '';
			this.showPassword = false;
			this.isRegistering = false;
			this.isConfirming = false;
			this.error = '';
		}
	},
	watch: {
		profile(newValue) {
			this.profile = newValue.replace(/\s\s+/g, ' ');
		}
	},
	created() {
		window.addEventListener('keydown', this.handleKeydown);
	},
	beforeUnmount() {
		window.removeEventListener('keydown', this.handleKeydown);
	},

};
</script>
<style src="@/assets/user-shared.css"/>